<template>
  <div>
    <h3 :class="['title', 'font-weight-light', 'pb-3', `${$config.colors.primary}--text`]">
      <slot />
    </h3>
    <v-divider :class="['mb-3']" />
  </div>
</template>
<script>
export default {
  name: 'SectionHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/section-header.vue